import { SyncStates } from './user-account-request';

export interface ProvisioningStateUI {
  text: string;
  class: string;
  icon: string;
  color?: string; // Opcional, por si necesitas colores hexadecimales específicos
}

export const PROVISIONING_STATE_UI: Record<number, ProvisioningStateUI> = {
  [SyncStates.Pending]: {
    text: 'userRequest.statePending',
    class: 'badge-secondary',
    icon: 'clock'
  },
  [SyncStates.Processing]: {
    text: 'userRequest.stateProcessing',
    class: 'badge-warning',
    icon: 'spinner fa-spin'
  },
  [SyncStates.Executed]: {
    text: 'userRequest.stateExecuted',
    class: 'badge-success',
    icon: 'check-circle'
  },
  [SyncStates.Partial]: {
    text: 'userRequest.statePartial',
    class: 'badge-warning',
    icon: 'exclamation-triangle',
    color: '#fd7e14'
  },
  [SyncStates.Failed]: {
    text: 'userRequest.stateFailed',
    class: 'badge-danger',
    icon: 'times-circle'
  },
  [SyncStates.Retrying]: {
    text: 'userRequest.stateRetrying',
    class: 'badge-info',
    icon: 'sync fa-spin'
  }
};